import { IronOverlayBehavior } from '@polymer/iron-overlay-behavior/iron-overlay-behavior';
import { mixinBehaviors } from '@polymer/polymer/lib/legacy/class';
export const ZuiDialogBehaviorMixin = superClass => {
  return class extends mixinBehaviors(IronOverlayBehavior, superClass) {
    static get properties() {
      return {
        noCancelOutsideDialog: {
          type: Boolean,
          value: false,

          observer(value) {
            this._closeOptionsChanged(value);
          }

        },
        hideBackdrop: {
          type: Boolean,
          value: false,

          observer(value) {
            this._hideBackdropChanged(value);
          }

        }
      };
    }

    constructor() {
      super();
      this.properties.withBackdrop.value = true;
      this.restoreFocusOnClose = true;
      this.addEventListener('click', this._onDialogClick);
      this.addEventListener('iron-overlay-canceled', () => {
        this._triggerCloseEvent(false);
      });
      let body = document.querySelector('body');
      this.addEventListener('opened-changed', e => {
        body.style.overflow = e.detail.value ? 'hidden' : 'auto';
      });
    }

    _closeOptionsChanged(value) {
      if (value) {
        this.noCancelOnOutsideClick = true;
        this.noCancelOnEscKey = true;
      } else {
        this.noCancelOnOutsideClick = false;
        this.noCancelOnEscKey = false;
      }
    }

    _hideBackdropChanged(value) {
      this.withBackdrop = !value;
    }

    _onDialogClick(event) {
      const path = event.path || event.composedPath && event.composedPath();

      if (path.indexOf(this) === 0 && !this.noCancelOnOutsideClick) {
        this._triggerCloseEvent(false);

        this.close();
        event.stopPropagation();
      } else {
        for (let i = 0, l = path.indexOf(this); i < l; i++) {
          const target = path[i];

          if (target.hasAttribute && (target.hasAttribute('dialog-close') || target.hasAttribute('dialog-confirm'))) {
            this._triggerCloseEvent(target.hasAttribute('dialog-confirm'));

            this.close();
            event.stopPropagation();
            break;
          }
        }
      }
    }

    _triggerCloseEvent(val) {
      this.dispatchEvent(new CustomEvent('close', {
        detail: val
      }));
    }

  };
};